import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { PrisonerPage } from './pages/PrisonerPage';
import { AuthPage } from './pages/AuthPage';
import { AuthCallback } from './pages/AuthCallback';
import { GameHistoryPage } from './pages/GameHistoryPage';
import { UserAgentsPage } from './pages/UserAgentsPage';
import { TrumanPage } from './pages/TrumanPage';
import { StoryHome } from './pages/StoryHome';
import { CharacterGallery } from './pages/CharacterGallery';
import { DBChainPage } from './pages/DBChainPage';
import LaunchPage from './pages/LaunchPage';
import DocumentationPage from './pages/DocumentationPage';

import { AuthProvider, useAuth } from './contexts/AuthContext';

const AppContent = () => {
  const { user, signInWithGithub, signOut } = useAuth();

  return (
    <Routes>
      {/* 新的启动页面作为首页 */}
      <Route path="/" element={<LaunchPage />} />
      {/* 文档页面 */}
      <Route path="/docs" element={<DocumentationPage />} />
      {/* <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/game" element={<TrumanPage />} /> */}

      <Route
        path="*"
        element={
          <Layout
            isAuthenticated={!!user}
            userProfile={user?.profile}
            onSignIn={signInWithGithub}
            onSignOut={signOut}
          >
            <Routes>
              {/* 原首页移到 /home 路径 */}
              {/* <Route path="/home" element={<HomePage />} />
              <Route path="/prisoner" element={<PrisonerPage />} />
              <Route path="/game_history" element={<GameHistoryPage />} /> */}
              {/* <Route path="/user_agents" element={<UserAgentsPage />} />
              <Route path="/story" element={<StoryHome />} />
              <Route path="/character_gallery" element={<CharacterGallery />} />
              <Route path="/db_chain" element={<DBChainPage />} />
              <Route path="/db_chain/block/:blockHash" element={<DBChainPage />} />
              <Route path="/db_chain/hash/:hash" element={<DBChainPage />} /> */}

            </Routes>
          </Layout>
        }
      />
    </Routes>
  );
};

export const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};
